<template>
  <div id="app">
    <TheNavbar
      :connected="connected"
      @signOut="signOut"
    />
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TheNavbar from './components/TheNavbar.vue';

export default {
  name: 'App',
  components: {
    TheNavbar,
  },
  computed: mapGetters('authentication', ['connected']),
  created() {
    this.fetchMe();
  },
  methods: mapActions('authentication', ['signOut', 'fetchMe']),
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Exo&display=swap');
#app {
  font-family: Exo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.button-bold {
  font-weight: bold;
}
</style>
